import { ThemeProvider } from '@mui/material'
import { useEffect } from 'react'
import { useLazyGetHasPartialMediaQuery } from '@/features/media/api.ts'
import {
  getMediaState,
  setHeaderMessage,
  setPartialMedia,
  setWhatsNewHtml,
} from '@/features/media/slice'
import {
  useLazyGetHeaderMessageQuery,
  useLazyGetWhatsNewTextQuery,
} from '@/features/whats-new/api.ts'
import { gaDecodeTokenAction } from './features/analytics/googleAnalyticsDecodeJWT'
import { useOneTrust } from './features/analytics/oneTrust/useOneTrust.ts'
import { useGTM } from './features/analytics/useGTM.ts'
import { useAuth } from './features/auth/hooks/useAuth.ts'
import { useAppDispatch, useAppSelector } from './redux/hooks'
import Routing from './routing'
import themeCat from './themes/theme-cat.ts'
import themePerkins from './themes/theme-perkins.ts'

function App() {
  useOneTrust()
  useGTM()
  const auth = useAuth()

  const dispatch = useAppDispatch()
  const isPerkins: boolean = useAppSelector(getMediaState).isPerkins

  const [
    getHasPartialMedia,
    { isSuccess: partialMediaSuccess, data: partialMediaData },
  ] = useLazyGetHasPartialMediaQuery()

  const [
    getHeaderMessage,
    { isSuccess: headerMessageSuccess, data: headerMessageData },
  ] = useLazyGetHeaderMessageQuery()

  const [getWhatsNew, { isSuccess: whatsNewSuccess, data: whatsNewData }] =
    useLazyGetWhatsNewTextQuery()

  useEffect(() => {
    if (auth.token) {
      dispatch(gaDecodeTokenAction(auth.token, true))
      getHasPartialMedia()
      getHeaderMessage()
      getWhatsNew()
    }
  }, [auth.token, dispatch, getHasPartialMedia, getHeaderMessage, getWhatsNew])

  useEffect(() => {
    if (partialMediaSuccess) dispatch(setPartialMedia(partialMediaData))
    if (headerMessageSuccess) dispatch(setHeaderMessage(headerMessageData))
    if (whatsNewSuccess) dispatch(setWhatsNewHtml(whatsNewData))
  }, [
    partialMediaSuccess,
    partialMediaData,
    headerMessageSuccess,
    headerMessageData,
    whatsNewSuccess,
    whatsNewData,
    dispatch,
  ])

  return (
    <ThemeProvider theme={isPerkins ? themePerkins : themeCat}>
      <Routing />
    </ThemeProvider>
  )
}

export default App
